import { isNil } from 'lodash';
import { MBIconV2Name } from '@shared/components/image';
import { RelatedCardComponent } from '@shared/scenes/workflows/config';
import { i18n } from '@shared/util/i18n';
import { NestedOptionsRow } from '../NestedOptionsRow';
import { LinkableWorkflow } from './RelatedCardLinkingOptions';
interface Props {
  component: RelatedCardComponent;
  selectedWorkflow?: LinkableWorkflow;
  enabled: boolean;
}

export function RelatedCardLinkingRow({ component, selectedWorkflow, enabled }: Props) {
  const cardText = !isNil(selectedWorkflow)
    ? selectedWorkflow.name
    : i18n('builder.relatedCardOptions.selectWorkflow');

  return (
    <NestedOptionsRow
      name={cardText}
      imageUrl={selectedWorkflow?.imageUrl}
      defaultIcon={component.icon as MBIconV2Name}
      selectedIcon="chat-bubbles-square"
      enabled={enabled}
    />
  );
}
